export default __webpack_public_path__ + "static/media/project-details2.9a298cc9.jpg";